import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import {
	OWL_DATE_TIME_FORMATS,
	OwlDateTimeIntl,
	OwlDateTimeModule,
	OwlNativeDateTimeModule,
} from "@danielmoncada/angular-datetime-picker";
import { TableModule } from "ngx-easy-table";
import { FooterComponent } from "../footer/footer.component";
import { HeaderComponent } from "../header/header.component";
import { SharedModule } from "../shared/shared.module";
import { SidebarComponent } from "../sidebar/sidebar.component";
import { CbtaWebRoutingModule } from "./cbta-web-routing.module";
import { CbtaWebComponent } from "./cbta-web.component";

import { CbtaFormNavigatorComponent } from "../shared/components/cbta-form-navigator/cbta-form-navigator.component";
import { DefaultIntl, MY_MOMENT_DATE_TIME_FORMATS } from "../shared/constants/angular-datetime-picker.const";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { AddManeuverNewComponent } from "./forms/create-form/add-maneuver-new/add-maneuver-new.component";
import { AddManeuverComponent } from "./forms/create-form/add-maneuver/add-maneuver.component";
import { CreateFormComponent } from "./forms/create-form/create-form.component";
import { FormCardComponent } from "./forms/create-form/form-card/form-card.component";
import { ObContainerComponent } from "./forms/create-form/ob-container/ob-container.component";
import { CreateUserComponent } from "./forms/create-user/create-user.component";
import { EditFormComponent } from "./forms/edit-form/edit-form.component";
import { EditUserComponent } from "./forms/edit-user/edit-user.component";
import { FormsComponent } from "./forms/forms.component";
import { UserManagementComponent } from "./forms/user-management/user-management.component";
import { InstructorVerificationComponent } from "./instructor-verification/instructor-verification.component";
import { PendingComponent } from "./pending/pending.component";
import { PilotDataFilesComponent } from "./pilot-data/files/files.component";
import { PilotDataFoldersComponent } from "./pilot-data/folders/folders.component";
import { PilotDataComponent } from "./pilot-data/pilot-data.component";
import { PilotDataUploadComponent } from "./pilot-data/upload/upload.component";
import { ProfileComponent } from "./profile/profile.component";
import { ReportComponent } from "./report/report.component";

import { CandidateDetailsComponent } from "./ratings/container-ratings-form/shared-rating-form/candidate-details/candidate-details.component";
import { QuickRatingSummaryComponent } from "./ratings/container-ratings-form/shared-rating-form/candidate-details/quick-rating-summary/quick-rating-summary.component";

import { CandidateRatingFormComponent } from "./ratings/container-ratings-form/shared-rating-form/candidate-rating-form/candidate-rating-form.component";

import { CandidateSignoffFormComponent } from "./ratings/container-ratings-form/shared-rating-form/candidate-signoff-form/candidate-signoff-form.component";

import { OtherTrainingObservationsComponent } from "./ratings/container-ratings-form/shared-rating-form/other-training-observations/other-training-observations.component";

import { ChecklistCandidateSignoffComponent } from "./checklist/checklist-candidate-signoff.component";
import { ChecklistDetailComponent } from "./checklist/checklist-detail.component";
import { ChecklistComponent } from "./checklist/checklist.component";
import { ChecklistFeedbackRouteComponent } from "./checklist/feedback/checklist-feedback-route.component";
import { ChecklistFeedbackComponent } from "./checklist/feedback/checklist-feedback.component";
import { FeedbackFormComponent } from "./feedback/feedback-form/feedback-form.component";
import { FeedbackRatingScaleComponent } from "./feedback/feedback-rating-legend/feedback-rating-legend.component";
import { FeedbackManagementComponent } from "./feedback/feedback-management/feedback-management.component";
import { FeedbackResponseDetailComponent } from "./feedback/feedback-response-detail/feedback-response-detail.component";
import { FeedbackResponsesComponent } from "./feedback/feedback-responses/feedback-responses.component";
import { MyFeedbackDetailComponent } from "./feedback/my-feedback-detail/my-feedback-detail.component";
import { MyFeedbackComponent } from "./feedback/my-feedback/my-feedback.component";
import { ManeuverFormComponent } from "./forms/create-form/maneuver-form/maneuver-form.component";
import { ObContainerSingleSelectionComponent } from "./forms/create-form/ob-container-single-selection/ob-container-single-selection.component";
import { Ts1AssessmentConfigComponent } from "./forms/ts1-v2/ts1-assessment-config/ts1-assessment-config.component";
import { Ts1AssessmentObTableComponent } from "./forms/ts1-v2/ts1-assessment-ob-table/ts1-assessment-ob-table.component";
import { Ts1FormConfigComponent } from "./forms/ts1-v2/ts1-form-config/ts1-form-config.component";
import { Ts1ManeuverSidebarComponent } from "./forms/ts1-v2/ts1-maneuver-sidebar/ts1-maneuver-sidebar.component";
import { Ts1OverallObCountSummaryComponent } from "./forms/ts1-v2/ts1-overall-ob-count-summary/ts1-overall-ob-count-summary.component";
import { Ts1ReminderNotesModalComponent } from "./forms/ts1-v2/ts1-reminder-notes-modal/ts1-reminder-notes-modal.component";
import { Ts1RoleObCounterComponent } from "./forms/ts1-v2/ts1-role-ob-counter/ts1-role-ob-counter.component";
import { Ts1SelectManeuverModalComponent } from "./forms/ts1-v2/ts1-select-maneuver-modal/ts1-select-maneuver-modal.component";
import { Ts1SessionConfigComponent } from "./forms/ts1-v2/ts1-session-config/ts1-session-config.component";
import { Ets1AocSessionConfigComponent } from "./forms/ts1-v2/ets1-aoc-session-config/ets1-aoc-session-config.component";
import { Ets1ReminderNotesConfigComponent } from "./forms/ts1-v2/ets1-reminder-notes-config/ets1-reminder-notes-config.component";
import { Ets1RatingReminderNotesComponent } from "./ratings/container-ratings-form/shared-v2/ets1-rating-reminder-notes/ets1-rating-reminder-notes.component";
import { Ts1SessionRemarkModalComponent } from "./forms/ts1-v2/ts1-session-remark-modal/ts1-session-remark-modal.component";
import { CabinCrewInstructorRatingFormV2Component } from "./ratings/container-ratings-form/cabin-crew-instructor-rating-form-v2/cabin-crew-instructor-rating-form-v2.component";
import { CabinCrewInstructorRatingFormComponent } from "./ratings/container-ratings-form/cabin-crew-instructor-rating-form/cabin-crew-instructor-rating-form.component";
import { CabinCrewRatingFormV2Component } from "./ratings/container-ratings-form/cabin-crew-rating-form-v2/cabin-crew-rating-form-v2.component";
import { CabinCrewRatingFormComponent } from "./ratings/container-ratings-form/cabin-crew-rating-form/cabin-crew-rating-form.component";
import { ContainerRatingsFormComponent } from "./ratings/container-ratings-form/container-ratings-form.component";
import { AddManeuverFormV2Component } from "./ratings/container-ratings-form/shared-rating-form-v2/add-maneuver-form/add-maneuver-form.component";
import { CandidateDetailsGroupFlightV2Component } from "./ratings/container-ratings-form/shared-rating-form-v2/candidate-details-group-flight/candidate-details-group-flight.component";
import { CandidateDetailsGroupSessionV2Component } from "./ratings/container-ratings-form/shared-rating-form-v2/candidate-details-group-session/candidate-details-group-session.component";
import { CandidateRatingFixedManeuverV2Component } from "./ratings/container-ratings-form/shared-rating-form-v2/candidate-rating-fixed-maneuver/candidate-rating-fixed-maneuver.component";
import { CandidateRatingFlexibleManeuverV2Component } from "./ratings/container-ratings-form/shared-rating-form-v2/candidate-rating-flexible/candidate-rating-flexible-maneuver.component";
import { CandidateRatingV2Component } from "./ratings/container-ratings-form/shared-rating-form-v2/candidate-rating/candidate-rating.component";
import { FlightSimulatorSummaryFieldsV2Component } from "./ratings/container-ratings-form/shared-rating-form-v2/flight-simulator-summary-fields/flight-simulator-summary-fields.component";
import { ObservationCardV2Component } from "./ratings/container-ratings-form/shared-rating-form-v2/observation-card/observation-card.component";
import { PreviewSummaryV2Component } from "./ratings/container-ratings-form/shared-rating-form-v2/preview-summary/preview-summary.component";
import { AddManeuverFormComponent } from "./ratings/container-ratings-form/shared-rating-form/add-maneuver-form/add-maneuver-form.component";
import { CandidateDetailsGroupFlightComponent } from "./ratings/container-ratings-form/shared-rating-form/candidate-details-group-flight/candidate-details-group-flight.component";
import { CandidateDetailsGroupSessionComponent } from "./ratings/container-ratings-form/shared-rating-form/candidate-details-group-session/candidate-details-group-session.component";
import { CandidateRatingFixedManeuverComponent } from "./ratings/container-ratings-form/shared-rating-form/candidate-rating-fixed-maneuver/candidate-rating-fixed-maneuver.component";
import { CandidateRatingFlexibleManeuverComponent } from "./ratings/container-ratings-form/shared-rating-form/candidate-rating-flexible/candidate-rating-flexible-maneuver.component";
import { CandidateRatingComponent } from "./ratings/container-ratings-form/shared-rating-form/candidate-rating/candidate-rating.component";
import { CandidateSignoffGradingComponent } from "./ratings/container-ratings-form/shared-rating-form/candidate-signoff-grading/candidate-signoff-grading.component";
import { CandidateSignoffNoGradingComponent } from "./ratings/container-ratings-form/shared-rating-form/candidate-signoff-no-grading/candidate-signoff-no-grading.component";
import { ObservationCardComponent } from "./ratings/container-ratings-form/shared-rating-form/observation-card/observation-card.component";
import { OtherTrainingCommentsComponent } from "./ratings/container-ratings-form/shared-rating-form/other-training-comments/other-training-comments.component";
import { PreviewSummaryComponent } from "./ratings/container-ratings-form/shared-rating-form/preview-summary/preview-summary.component";
import { QuickRatingSummaryDetailsComponent } from "./ratings/container-ratings-form/shared-rating-form/quick-rating-summary-details/quick-rating-summary-details.component";
import { RemoteSignoffShellComponent } from "./ratings/container-ratings-form/shared-v2/remote-signoff/remote-signoff-shell/remote-signoff-shell.component";
import { Ts1RatingFormV2Component } from "./ratings/container-ratings-form/ts1-rating-form-v2/ts1-rating-form-v2.component";
import { Ts1RatingPreviewSummaryComponent } from "./ratings/container-ratings-form/ts1-rating-form-v3/preview/ts1-rating-preview-summary/ts1-rating-preview-summary.component";
import { Ts1RatingStep2V2Component } from "./ratings/container-ratings-form/ts1-rating-form-v3/steps/step2/ts1-rating-step2-v2/ts1-rating-step2-v2.component";
import { Ts1RatingStep3ReviewComponent } from "./ratings/container-ratings-form/ts1-rating-form-v3/steps/step3/ts1-rating-step3-review/ts1-rating-step3-review.component";
import { Ts1RatingStep4SignoffComponent } from "./ratings/container-ratings-form/ts1-rating-form-v3/steps/step4/ts1-rating-step4-signoff/ts1-rating-step4-signoff.component";
import { Ts1RatingFormV3Component } from "./ratings/container-ratings-form/ts1-rating-form-v3/ts1-rating-form-v3.component";
import { Ts1RatingManeuverOutcomeComponent } from "./ratings/container-ratings-form/ts1-rating-form-v3/widgets/ts1-rating-maneuver-outcome/ts1-rating-maneuver-outcome.component";
import { Ts1RatingManeuverSidebarComponent } from "./ratings/container-ratings-form/ts1-rating-form-v3/widgets/ts1-rating-maneuver-sidebar/ts1-rating-maneuver-sidebar.component";
import { Ts1RatingObPanelComponent } from "./ratings/container-ratings-form/ts1-rating-form-v3/widgets/ts1-rating-ob-panel/ts1-rating-ob-panel.component";
import { Ts1RatingFormV4Component } from "./ratings/container-ratings-form/ts1-rating-form-v4/ts1-rating-form-v4.component";
import { Ts3RatingFormV2Component } from "./ratings/container-ratings-form/ts3-rating-form-v2/ts3-rating-form-v2.component";
import { Ts3RatingFormComponent } from "./ratings/container-ratings-form/ts3-rating-form/ts3-rating-form.component";
import { Ts5RatingFormV2Component } from "./ratings/container-ratings-form/ts5-rating-form-v2/ts5-rating-form-v2.component";
import { Ts5RatingFormComponent } from "./ratings/container-ratings-form/ts5-rating-form/ts5-rating-form.component";
import { Ts6RatingFormV2Component } from "./ratings/container-ratings-form/ts6-rating-form-v2/ts6-rating-form-v2.component";
import { Ts6RatingFormComponent } from "./ratings/container-ratings-form/ts6-rating-form/ts6-rating-form.component";
import { RatingsComponent } from "./ratings/ratings.component";
import { Ts1PfpmReportLayoutComponent } from "./report/report-summary/layouts/ts1-pfpm-report-layout/ts1-pfpm-report-layout.component";
import { ReportSummaryComponent } from "./report/report-summary/report-summary.component";
import { Ts1ReportPreviewSummaryComponent } from "./report/report-summary/ts1-report-preview-summary/ts1-report-preview-summary.component";
import { Ts1V3ManeuverBreakdownComponent } from "./report/report-summary/ts1-v3-maneuver-breakdown/ts1-v3-maneuver-breakdown.component";
import { Ts1V3ReportSummaryComponent } from "./report/report-summary/ts1-v3-report-summary/ts1-v3-report-summary.component";
import { Ts1V4ManeuverBreakdownComponent } from "./report/report-summary/ts1-v4-maneuver-breakdown/ts1-v4-maneuver-breakdown.component";
import { Ts1V4ReportSummaryComponent } from "./report/report-summary/ts1-v4-report-summary/ts1-v4-report-summary.component";
import { TrainingDetailsComponent } from "./report/training-details/training-details.component";
import { ViewManeuverComponent } from "./report/view-maneuver/view-maneuver.component";

@NgModule({
	declarations: [
		CbtaWebComponent,
		HeaderComponent,
		FooterComponent,
		SidebarComponent,
		DashboardComponent,
		ReportComponent,
		FormsComponent,
		InstructorVerificationComponent,
		ProfileComponent,
		CreateFormComponent,
		AddManeuverComponent,
		AddManeuverFormComponent,
		AddManeuverFormV2Component,
		FormCardComponent,
		TrainingDetailsComponent,
		RatingsComponent,
		Ts6RatingFormComponent,
		Ts6RatingFormV2Component,
		Ts5RatingFormComponent,
		Ts5RatingFormV2Component,
		Ts3RatingFormComponent,
		Ts3RatingFormV2Component,
		CabinCrewRatingFormComponent,
		CabinCrewRatingFormV2Component,
		ContainerRatingsFormComponent,
		CandidateDetailsComponent,
		CandidateDetailsGroupSessionComponent,
		CandidateDetailsGroupSessionV2Component,
		ReportSummaryComponent,
		CbtaFormNavigatorComponent,
		CandidateRatingFormComponent,
		CandidateSignoffFormComponent,
		EditFormComponent,
		QuickRatingSummaryComponent,
		OtherTrainingObservationsComponent,
		ViewManeuverComponent,
		PendingComponent,
		AddManeuverNewComponent,
		ObContainerComponent,
		UserManagementComponent,
		CreateUserComponent,
		EditUserComponent,
		PilotDataComponent,
		PilotDataUploadComponent,
		PilotDataFoldersComponent,
		PilotDataFilesComponent,
		ObservationCardComponent,
		ObservationCardV2Component,
		CandidateRatingComponent,
		CandidateRatingV2Component,
		CandidateSignoffNoGradingComponent,
		OtherTrainingCommentsComponent,
		ManeuverFormComponent,
		CandidateRatingFixedManeuverComponent,
		CandidateRatingFixedManeuverV2Component,
		CandidateDetailsGroupFlightComponent,
		CandidateDetailsGroupFlightV2Component,
		CandidateSignoffGradingComponent,
		FlightSimulatorSummaryFieldsV2Component,
		QuickRatingSummaryDetailsComponent,
		PreviewSummaryComponent,
		PreviewSummaryV2Component,
		Ts1RatingFormV2Component,
		Ts1RatingFormV3Component,
		Ts1RatingFormV4Component,
		Ts1RatingStep2V2Component,
		Ts1RatingManeuverSidebarComponent,
		Ts1RatingObPanelComponent,
		Ts1RatingManeuverOutcomeComponent,
		Ts1RatingStep3ReviewComponent,
		Ts1RatingStep4SignoffComponent,
		Ts1RatingPreviewSummaryComponent,
		Ts1ReportPreviewSummaryComponent,
		Ts1V3ReportSummaryComponent,
		Ts1V3ManeuverBreakdownComponent,
		Ts1V4ReportSummaryComponent,
		Ts1V4ManeuverBreakdownComponent,
		Ts1PfpmReportLayoutComponent,
		ChecklistComponent,
		ChecklistDetailComponent,
		ChecklistCandidateSignoffComponent,
		ChecklistFeedbackComponent,
		ChecklistFeedbackRouteComponent,
		CandidateRatingFlexibleManeuverComponent,
		CandidateRatingFlexibleManeuverV2Component,
		ObContainerSingleSelectionComponent,
		CabinCrewInstructorRatingFormComponent,
		CabinCrewInstructorRatingFormV2Component,
		Ts1AssessmentConfigComponent,
		Ts1ManeuverSidebarComponent,
		Ts1AssessmentObTableComponent,
		Ts1OverallObCountSummaryComponent,
		Ts1RoleObCounterComponent,
		Ts1SelectManeuverModalComponent,
		Ts1SessionConfigComponent,
		Ets1AocSessionConfigComponent,
		Ets1ReminderNotesConfigComponent,
		Ets1RatingReminderNotesComponent,
		Ts1SessionRemarkModalComponent,
		Ts1FormConfigComponent,
		Ts1ReminderNotesModalComponent,
		RemoteSignoffShellComponent,
		FeedbackManagementComponent,
		FeedbackFormComponent,
		FeedbackRatingScaleComponent,
		FeedbackResponsesComponent,
		FeedbackResponseDetailComponent,
		MyFeedbackComponent,
		MyFeedbackDetailComponent,
	],
	imports: [CommonModule, CbtaWebRoutingModule, SharedModule, TableModule, OwlDateTimeModule, OwlNativeDateTimeModule],
	providers: [
		{ provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_DATE_TIME_FORMATS },
		{ provide: OwlDateTimeIntl, useClass: DefaultIntl },
	],
})
export class CbtaWebModule {}
